import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Portfolio } from '../portfolio-review/portfolio';
import { UrlSignature } from './apiEndPoint';
import { CertificateProgramme } from './certificateprogramme';
import { City } from './city';
import { Country } from './country';
import { Gender } from './gender';
import { ProgrammeType } from './programmeType';
import { Region } from './region';
import { Religion } from './religion';
import { Response } from './response';
import { Title } from './title';

@Injectable()
export class CommonService {
  constructor(private httpClient: HttpClient, private urlSignature: UrlSignature) {}

  getReligion(): Observable<Religion[]> {
    const url = this.urlSignature.religionListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Religion[]));
  }

  getCountryList(): Observable<Country[]> {
    const url = this.urlSignature.countryListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Country[]));
  }

  getCityName(cityId: number): Observable<City> {
    const url = this.urlSignature.cityByIdUrl + cityId;
    return this.httpClient.get(url).pipe(map((response) => response as City));
  }

  getProgrammeTypes(): Observable<ProgrammeType[]> {
    const url = this.urlSignature.programmeTypesUrl;
    return this.httpClient.get(url).pipe(map((response) => response as ProgrammeType[]));
  }

  getTitleList(): Observable<Title[]> {
    const url = this.urlSignature.titleListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Title[]));
  }

  getGenderList(): Observable<Gender[]> {
    const url = this.urlSignature.genderListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Gender[]));
  }

  getRegionList(): Observable<Region[]> {
    const url = this.urlSignature.regionListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Region[]));
  }

  getPassPortPhotoUrl(photoName: string): string {
    return this.urlSignature.photoLinkUrl + photoName;
  }

  getPortfolioUrl(portfolio: Portfolio): void {
    if (portfolio.attachment.endsWith('.pdf')) {
      portfolio.attachmentUrl = this.urlSignature.acdtUrl + '/img/Adobe-PDF-Document-icon.png';
    } else {
      portfolio.attachmentUrl =
        this.urlSignature.acdtUrl +
        '/attachments' +
        this.urlSignature.environment +
        '/portfolios/' +
        portfolio.attachment;
    }
  }

  getCertificateProgrammeList(): Observable<CertificateProgramme[]> {
    const url = this.urlSignature.certificateProgrammeListUrl;
    return this.httpClient.get(url).pipe(map((response) => response as CertificateProgramme[]));
  }

  getCurrentYear(): Observable<Response> {
    const url = this.urlSignature.currentYearUrl;
    return this.httpClient.get(url).pipe(map((response) => response as Response));
  }

  getCountryName(countryId: string | number): Observable<Country[]> {
    const url = this.urlSignature.countryUrl + countryId;
    return this.httpClient.get(url).pipe(map((response) => response as Country[]));
  }

  getCityByCountry(countryId: string): Observable<City[]> {
    const url = this.urlSignature.cityListForCountry + countryId;
    return this.httpClient.get(url).pipe(map((response) => response as City[]));
  }

  uploadFiles(fileName: string, directory: string, formData: FormData): Observable<string> {
    const url = this.urlSignature.uploadFileUrl + directory + '/' + fileName;

    return this.httpClient.post(url, formData, { responseType: 'text' }).pipe(map((response) => response as string));
  }

  sendContactUsEmail(emailDetails: string): Observable<string> {
    const url = this.urlSignature.enquiryUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.httpClient.post(url, emailDetails, httpOptions).pipe(map((response) => response as string));
  }
}